// extracted by mini-css-extract-plugin
export default {"list":"vxaKb","item":"KYEuC","link":"q7ARV","linkSelected":"jW6fS"};